import React, {useEffect} from 'react';
import {useRecoilRefresher_UNSTABLE, useRecoilValue} from 'recoil';
import dayjs from 'dayjs';

import {BenefitListItems} from '@/store';

import styles from '../styles.module.scss';
import OrderItem from './OrderItem';
import {useScroll} from '../../../hooks/useScroll';

export default function BenefitItems() {
  const {syncScroll} = useScroll();
  const orderList = useRecoilValue(BenefitListItems);
  const refetchOrderList = useRecoilRefresher_UNSTABLE(BenefitListItems);
  const getStatus = (item: OrderListItem) => {
    const today = dayjs();
    const approvedDate = dayjs(item.expired);
    if (
      item.usedStatus === '구매 완료' &&
      today.diff(approvedDate, 'day') > 0
    ) {
      return '기간 만료';
    }
    if (item.usedStatus === '구매 완료') {
      return '사용 전';
    }
    return item.usedStatus;
  };
  useEffect(() => {
    refetchOrderList();
    syncScroll();
  }, []);
  return (
    orderList && (
      <div className={styles.order_list}>
        <div
          className={styles.no_order_items}
          style={{
            display: orderList.length === 0 ? 'flex' : 'none',
            marginTop: '-78px',
          }}>
          받은 혜택권이 없습니다.
        </div>
        <div style={{display: orderList.length > 0 ? 'block' : 'none'}}>
          {orderList.map((item, idx) => {
            return (
              <OrderItem
                key={`order_item_idx_${idx}`}
                status={
                  getStatus(item) as
                    | '구매 완료'
                    | '취소 요청'
                    | '취소 완료'
                    | '사용 완료'
                    | '기간 만료'
                    | '사용 전'
                }
                item={item}
                type={'benefit'}
              />
            );
          })}
        </div>
      </div>
    )
  );
}
